import React from 'react';

const styles = `
.sobre-page {
  min-height: 100vh;
  background-color: white;
}

.sobre-hero {
  padding: 4rem 0 3rem;
  background: linear-gradient(to bottom, #f0f9f9, white);
  text-align: center;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.sobre-title {
  font-size: 3rem;
  color: #5A9C9C;
  margin-bottom: 1rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.sobre-subtitle {
  font-size: 1.25rem;
  color: #4A8080;
  font-style: italic;
  margin-bottom: 2rem;
}

.sobre-content {
  padding: 4rem 0;
  background-color: white;
}

.content-wrapper {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1rem;
}

.content-intro {
  font-size: 1.25rem;
  color: #4A8080;
  text-align: center;
  margin-bottom: 2rem;
  line-height: 1.8;
  font-weight: 500;
}

.content-text {
  color: #4b5563;
  line-height: 1.8;
  font-size: 1.0625rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.content-highlight {
  color: #5A9C9C;
  font-weight: 600;
}

.image-section {
  padding: 3rem 0;
  background-color: #f9fafb;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.image-card {
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.image-card img {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.values-section {
  padding: 5rem 0;
  background-color: white;
}

.section-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 300;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.value-card {
  background-color: #f0f9f9;
  padding: 2rem;
  border-radius: 0.5rem;
  text-align: center;
  transition: transform 0.3s;
}

.value-card:hover {
  transform: translateY(-5px);
}

.value-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  background-color: #5A9C9C;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
}

.value-card h3 {
  font-size: 1.5rem;
  color: #4A8080;
  margin-bottom: 1rem;
}

.value-card p {
  color: #6b7280;
  line-height: 1.6;
}

.team-section {
  padding: 5rem 0;
  background-color: #f9fafb;
}

.team-intro {
  max-width: 800px;
  margin: 0 auto 3rem;
  text-align: center;
  color: #4b5563;
  font-size: 1.125rem;
  line-height: 1.8;
}

.cta-section {
  padding: 5rem 0;
  background-color: #4A8080;
  color: white;
  text-align: center;
}

.cta-title {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  font-weight: 300;
}

.cta-text {
  font-size: 1.125rem;
  margin-bottom: 2rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.8;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  padding: 1rem 2.5rem;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  text-decoration: none;
  display: inline-block;
}

.cta-btn-primary {
  background-color: white;
  color: #4A8080;
}

.cta-btn-primary:hover {
  background-color: #f3f4f6;
}

.cta-btn-secondary {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}

.cta-btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
  .sobre-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .cta-title {
    font-size: 2rem;
  }

  .values-grid {
    grid-template-columns: 1fr;
  }

  .image-grid {
    grid-template-columns: 1fr;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }

  .cta-btn {
    width: 100%;
    max-width: 300px;
  }
}
`;

export default function SobreNosPage() {
  return (
    <>
      <style>{styles}</style>
      <div className="sobre-page">
        <section className="sobre-hero">
          <div className="container">
            <h1 className="sobre-title">ESTE É UM LUGAR FELIZ</h1>
            <p className="sobre-subtitle">Barco de Papel - Academia de Criatividade</p>
          </div>
        </section>

        <section className="sobre-content">
          <div className="content-wrapper">
            <p className="content-intro">Venha visitar e veja...</p>
            
            <p className="content-text">
              O nosso espaço é luminoso, aberto e acolhedor.
            </p>
            
            <p className="content-text">
              Está dividido em dois espaços distintos mas que se complementam. De um lado podemos 
              encontrar todos os materiais para fazer um super projeto artístico sem medo de usar e 
              experimentar a cor.
            </p>
            
            <p className="content-text">
              Na nossa academia da criatividade as crianças podem se sentir livres e desinibidas 
              para explorar a imaginação sem preocupações.
            </p>
            
            <p className="content-text">
              Oferecemos também um espaço lúdico onde a imaginação é livre e a palavras brincar é 
              levada muito a sério. Funciona como um laboratório de experiências sensoriais e jogos 
              para aprender brincando. <span className="content-highlight">Sempre em boa companhia!</span>
            </p>
          </div>
        </section>

        <section className="image-section">
          <img src={"assets/image11.png"} alt="Imagem 1" />
        </section>
      </div>
    </>
  );
}